import React from 'react'

function SvgGraduateHatIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M4.167 8.333v5.01c0 .299 0 .448.045.58.04.117.106.223.193.312.097.1.231.166.499.3l4.5 2.25c.218.11.328.164.442.186a.836.836 0 00.308 0c.114-.022.224-.076.442-.186l4.5-2.25c.268-.134.402-.2.5-.3a.833.833 0 00.192-.312c.045-.132.045-.281.045-.58v-5.01M1.667 7.083l8.035-4.017c.11-.055.164-.082.221-.093.05-.01.103-.01.154 0 .057.01.112.038.221.093l8.035 4.017-8.035 4.018a.907.907 0 01-.221.093.418.418 0 01-.154 0 .907.907 0 01-.221-.093L1.667 7.083z"
      ></path>
    </svg>
  )
}

export default SvgGraduateHatIcon
